import React, { FunctionComponent } from 'react'
import YouTube from 'react-youtube'
import styled from 'styled-components'
import { AutoImage } from './auto-image'
import { ColoredTableBody, ColoredTableHead, ColoredTableItem, ColoredTableOuter, ColoredTableSubject } from './color-table'

const Outer = styled.div`
  margin-top: 2rem;
  @media (max-width: 40rem){
    margin-top: 0;
  }
`

const Text = styled.div`
  font-weight: 700;
  line-height: 2;
  margin-bottom: 2rem;
`

const Text2 = styled.div`
  line-height: 2;
  margin-top: 2rem;
  font-size: 0.9em;
`

const ImageContainer = styled.a`
  margin-top: 2rem;
  display: block;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
`

const YoutubeContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin-top: 1rem;
  & > * {
    width: 100%;
    display: block;
  }
  iframe {
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }

`

type ScheduleSectionProps = {

}
export const ScheduleSection: FunctionComponent<ScheduleSectionProps> = () => {
  return <Outer>
    <Text>コアラ組担任、預かり保育担当、学年フリー担当、プリスクール担当など、役割によって多少仕事内容は異なりますが、ここでは共通部分をご紹介します</Text>
    <ColoredTableOuter style={{'--columns': 5}}>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#00b2cc'}}>
          7：30～9：30 <small>※1</small>
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>出勤</ColoredTableSubject>
          掃除、環境設定、保育準備保育室の環境設定
          早番勤務スタート
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#a6ca5e'}}>
          8：00
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>朝礼</ColoredTableSubject>
          登園受入、視診
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#eea76e'}}>
          9：00
        </ColoredTableHead>
        <ColoredTableBody>
          担任バスクラスの補助
          <ColoredTableSubject>コアラ組</ColoredTableSubject>
          ※2（火・水・木・金）
          園児受け入れ、自由遊び
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#96607a'}}>
          10：00
        </ColoredTableHead>
        <ColoredTableBody>
          クラス補助、特別支援児行事準備、環境整備
          <ColoredTableSubject>コアラ組</ColoredTableSubject>
          ※2（～11:30降園）
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#fcd24d'}}>
          11：00
        </ColoredTableHead>
        <ColoredTableBody>
          クラス補助、発注物整理、配布物分類、製作物準備
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#9d92c1'}}>
          12：00
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>昼食・休憩</ColoredTableSubject>
          給食片付け、子どもの投薬
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#ed8599'}}>
          13：00
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>バスチェック</ColoredTableSubject>
          降園バス乗車<small>※2</small>
          クラス補助、園だより作成
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#f4b3c2'}}>
          14：00
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>預かり保育</ColoredTableSubject>
          ※2（～18:30）
          戸外遊び、集団ゲーム
          おやつ
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#69b02f'}}>
          15：00
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>おやつ・休憩</ColoredTableSubject>
          談笑、学年の仕事（製作物・翌日準備等～退勤まで）
        </ColoredTableBody>
      </ColoredTableItem>
      <ColoredTableItem>
        <ColoredTableHead style={{backgroundColor: '#66bfe1'}}>
          16：30～18:30 <small>※3</small>
        </ColoredTableHead>
        <ColoredTableBody>
          <ColoredTableSubject>退勤</ColoredTableSubject>
        </ColoredTableBody>
      </ColoredTableItem>
    </ColoredTableOuter>
    <Text2>
      ◆※1は4シフト制（7:30／8：00／8：30／9：30）<br />
      ◆プリスクール担任（乳児）は1日保育にあたりますので、上記のタイムスケジュールとは異なります。<br />
      ◆※2は担当のみ。<br />
      ◆※3は4シフト制（16:30／17：00／17：30／18：30）
    </Text2>
    <ImageContainer>
      <AutoImage src="/images/req_img_04.png" mobileSrc='/images/req_img_04_mobile.png' />
    </ImageContainer>
    <YoutubeContainer>
      <YouTube videoId='JTVL_jmkuLk' />
      <YouTube videoId='ZfUrV1MqNLE' />
    </YoutubeContainer>
    <ImageContainer href="https://www.youtube.com/channel/UCKdWbs154T5fYUmL4T1icgg" target="_blank">
      <AutoImage src="/images/req_img_07.png" />
    </ImageContainer>
  </Outer>
}